var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import ClinicReportsPerMonth from './ClinicReportsPerMonth';
import { plainToInstance } from 'class-transformer';
import TransactionReportsPerClinic from './TransactionReportsPerClinic';
var ClinicReport = /** @class */ (function (_super) {
    __extends(ClinicReport, _super);
    function ClinicReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClinicReport.prototype.getTotalPatients = function () {
        return Number(this.total_patients);
    };
    ClinicReport.prototype.getTotalPackageReservations = function () {
        return Number(this.total_package_reservations);
    };
    ClinicReport.prototype.getTotalAppointment = function () {
        return Number(this.total_appointments);
    };
    ClinicReport.prototype.getTotalTransactions = function () {
        return this.roundNumber(this.total_transactions);
    };
    ClinicReport.prototype.getAvgTransactions = function () {
        return this.roundNumber(this.avg_transactions);
    };
    ClinicReport.prototype.getReportsPerMonth = function () {
        return plainToInstance(ClinicReportsPerMonth, this.reports_per_month);
    };
    ClinicReport.prototype.getTransactionsPerClinic = function () {
        return plainToInstance(TransactionReportsPerClinic, this.transactions_per_clinic);
    };
    ClinicReport.prototype.getAppointmentsPerClinic = function () {
        return (this.appointments_per_clinic || []).map(function (row) { return ({
            clinicId: Number(row.clinic_id),
            clinicName: row.clinic_name,
            appointments: Number(row.appointments_count) || 0
        }); });
    };
    ClinicReport.prototype.getServiceOrders = function () {
        return (this.service_orders || []).map(function (row) { return ({
            entityType: row.entity_type,
            orders: Number(row.orders_count) || 0
        }); });
    };
    ClinicReport.prototype.getConsultationCompletion = function () {
        return this.optionalNumber(this.consultation_completion);
    };
    ClinicReport.prototype.getAvgConsultationMinutes = function () {
        return this.optionalNumber(this.avg_consultation_minutes);
    };
    ClinicReport.prototype.getCapacityRate = function () {
        return this.optionalNumber(this.capacity_rate);
    };
    ClinicReport.prototype.getPackageValue = function () {
        return this.optionalNumber(this.package_value);
    };
    ClinicReport.prototype.getRedemptionRate = function () {
        return this.optionalNumber(this.redemption_rate);
    };
    ClinicReport.prototype.getClinicMonths = function () {
        return this.clinic_months || [];
    };
    ClinicReport.prototype.getClinicCapacity = function () {
        return this.clinic_capacity || [];
    };
    ClinicReport.prototype.getClinicWeeks = function () {
        return this.clinic_weeks || [];
    };
    ClinicReport.prototype.getClinicLeads = function () {
        return this.clinic_leads || [];
    };
    ClinicReport.prototype.getMachineVisits = function () {
        return this.machine_visits || [];
    };
    ClinicReport.prototype.optionalNumber = function (value) {
        if (value == null)
            return null;
        var amount = Number(value);
        return Number.isFinite(amount) ? amount : null;
    };
    return ClinicReport;
}(Model));
export default ClinicReport;
